import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import {
    Layout,
    Row,
    Typography,
    Tabs,
    Divider,
    Image,
    Skeleton,
    Col,
} from 'antd'

// store
import { applyForJobDetail, jobState } from '../store/job.slice'

// assets
import Logo from '../../../assets/images/logo_dark.png'

// components
import Button from '../../../components/button/button'

import './index.css'
import ApplicationForm from './applicationForm'

const { Title, Text } = Typography

const ApplyForJobPublicPage = () => {
    const dispatch = useDispatch()

    const { id } = useParams()

    const { jobDetailsApply, jobLoading } = useSelector(jobState)

    const [activeKey, setActiveKey] = useState('overview')

    useEffect(() => {
        dispatch(applyForJobDetail(id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Layout
            style={{
                background: '#f3f5f8',
                minHeight: '100vh',
            }}
        >
            <div
                style={{
                    textAlign: 'center',
                    padding: '40px 20px 20px 20px',
                    backgroundColor: '#fff',
                }}
            >
                <Image src={Logo} alt="Logo" preview={false} height={64} />
                {jobLoading ? (
                    <Skeleton
                        style={{
                            margin: '20px auto 12px auto',
                            maxWidth: '300px',
                        }}
                        active
                        paragraph={{ rows: 3 }}
                        title={false}
                    />
                ) : (
                    <Row
                        style={{
                            flexDirection: 'column',
                            rowGap: '10px',
                        }}
                    >
                        <Title
                            level={3}
                            style={{
                                margin: '20px auto 12px auto',
                            }}
                        >
                            {jobDetailsApply?.title}
                        </Title>
                        <Text>{jobDetailsApply?.workplace}</Text>
                        <Text>{jobDetailsApply?.location}</Text>
                    </Row>
                )}
            </div>

            <Divider style={{ margin: 0 }} />

            <Tabs
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                centered
                tabBarStyle={{
                    backgroundColor: '#fff',
                    boxShadow: '0 6px 17px 2px rgba(49,59,70,.08)',
                }}
                rootClassName="job-application-tabs"
                items={[
                    {
                        key: 'overview',
                        label: 'OVERVIEW',
                        children: jobLoading ? (
                            <Row
                                style={{
                                    maxWidth: '668px',
                                    margin: 'auto',
                                }}
                            >
                                <Skeleton active paragraph={{ rows: 5 }} />
                            </Row>
                        ) : (
                            <Col
                                style={{
                                    maxWidth: '668px',
                                    margin: 'auto',
                                }}
                            >
                                <Row
                                    justify="space-between"
                                    align="middle"
                                    style={{ width: '100%' }}
                                >
                                    <Title level={4}>Description</Title>
                                </Row>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: jobDetailsApply?.description,
                                    }}
                                    style={{ marginTop: '6px' }}
                                />
                                {jobDetailsApply?.requirements && (
                                    <div>
                                        <Row
                                            justify="space-between"
                                            align="middle"
                                        >
                                            <Title level={4}>
                                                Requirements
                                            </Title>
                                        </Row>

                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: jobDetailsApply?.requirements,
                                            }}
                                            style={{ marginTop: '6px' }}
                                        />
                                    </div>
                                )}
                                {jobDetailsApply?.benefits && (
                                    <div>
                                        <Row
                                            justify="space-between"
                                            align="middle"
                                        >
                                            <Title level={4}>Benefits</Title>
                                        </Row>

                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: jobDetailsApply?.benefits,
                                            }}
                                            style={{ marginTop: '6px' }}
                                        />
                                    </div>
                                )}
                                <Row
                                    justify="center"
                                    style={{
                                        margin: '30px 0px',
                                        width: '100%',
                                    }}
                                >
                                    <Button
                                        props={{
                                            text: 'Apply for this job',
                                            style: { width: '100%' },
                                            onClick: () =>
                                                setActiveKey('application'),
                                        }}
                                    />
                                </Row>
                            </Col>
                        ),
                    },
                    {
                        key: 'application',
                        label: 'APPLICATION',
                        children: (
                            <Row
                                style={{
                                    maxWidth: '668px',
                                    margin: 'auto',
                                }}
                            >
                                <ApplicationForm />
                            </Row>
                        ),
                    },
                ]}
            />
        </Layout>
    )
}

export default ApplyForJobPublicPage
